import React from "react";

const ServiceCard = ({ service }) => (
  <div className="service-card">
    <div className="service-card-inner">
      <div className="service-card-front">
        <div className="service-icon">{service.icon}</div>
        <h3>{service.title}</h3>
        <p>{service.description}</p>
      </div>
      <div className="service-card-back">
        <h3>{service.title}</h3>
        <p>{service.details}</p>
      </div>
    </div>
  </div>
);

export default ServiceCard;
